import React from 'react';

const StatusBar = () => (
  <div></div>
);

export default StatusBar;



// WEBPACK FOOTER //
// ./app/header-builder/components/StatusBar.js